// extracted by mini-css-extract-plugin
export default {"cont":"ItemsContainer_cont__Eu3LZ"};